<template>
  <v-container fluid>
    <v-row>
      <v-col cols="10">
        <item-list-edit
          :dialog-visible="dialogVisible"
          :headers="headers"
          :items="item.value"
          title="Добавление новых элементов в Список"
          @close="onDialogClose"
          @save="onSaveList"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="12"
        sm="10"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="text-subtitle-1 font-weight-light">
              Редактирование атрибутов
            </div>
          </template>
          <v-card-text>
            <v-text-field
              v-model="item.nickname"
              label="Наименование"
            />
            <v-text-field
              v-if="attributeObj.type !== 5"
              v-model="item.byDefault"
              label="Значение по умолчанию"
            />
            <v-row v-if="attributeObj.type === 5">
              <v-col cols="10">
                <v-select
                  no-data-text="Небходимо заполнить данными"
                  :items="item.value"
                />
              </v-col>
              <v-col cols="2">
                <v-icon
                  large
                  color="primary"
                  @click="onDialogOpen"
                >
                  mdi-plus-circle-outline
                </v-icon>
              </v-col>
            </v-row>
            <v-text-field
              v-model="item.hint"
              label="Подсказка"
            />
            <v-text-field
              v-if="attributeObj.type !== 5"
              v-model="item.mask"
              label="Маска ввода"
            />
            <v-text-field
              v-model="item.validateText"
              label="Сообщение об ошибке"
            />
            <v-text-field
              v-model="item.order"
              type="number"
              hint="Порядок следования элементов ввода информации"
              label="Порядок следования"
            />
            <v-checkbox
              v-model="item.hidden"
              label="Скрытый"
            />
            <v-checkbox
              v-if="attributeObj.type !== 5"
              v-model="item.mandatory"
              label="Обязательный"
            />
            <v-checkbox
              v-model="item.readonly"
              label="Только для чтения"
            />
            <v-switch
              v-model="item.deleted"
              label="Удалён"
            />
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-row
              align-content="space-between"
              justify="space-around"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.back()"
              >
                Отменить
              </v-btn>
              <v-btn
                color="primary"
                @click="save"
              >
                Сохранить
              </v-btn>
            </v-row>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WebApi from "@/views/loyalty/shared/modules/web_api"
import ItemListEdit from "@/views/loyalty/shared/components/item-list/ItemListEdit"

export default {
  name: "CustomerVariableEdit",
  components: { ItemListEdit },
  data: () => ({
    attributeObj: {},
    dialogVisible: false,
    item: {},
    headers: [
      {
        text: "Свойство",
        value: "value"
},
      {
        text: "Удалить",
        value: "actions",
        sortable: false
      },
    ],
    webApi: null
  }),
  async beforeMount () {
    this.webApi = new WebApi(this.$store).readError('Не удалось загрузить данные').editSuccess('Данные успешно сохранены!').editError('Не удалось сохранить данные')
    this.item = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/customer_variable/${this.$route.params.cvariableId}`)
    this.attributeObj = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attribute/${this.item.attributeId}`)
    if (this.attributeObj.type === 5) {
      this.item.value = this.item.byDefault.split(';')
      console.log('this.item.value', this.item.value)
    }
  },
  methods: {
    onDialogClose () {
      this.dialogVisible = false
    },
    onDialogOpen () {
      this.dialogVisible = true
      console.log('onDialogOpen this.item.value', this.item.value)
    },
    onSaveList ($event) {
      console.log('$event', $event)
      this.item.value = $event.map(m => m.value)
      this.item.byDefault = this.item.value.join(';')
      console.log('this.item.value', this.item.value)
      console.log('this.item.byDefault', this.item.byDefault)
    },
    async save () {
      this.item = await this.webApi.patch(`${process.env.VUE_APP_LOYALTY_URL}api/customer_variable/${this.$route.params.cvariableId}`, this.item)
      if (this.attributeObj.type === 5) {
        this.item.value = this.item.byDefault.split(';')
        console.log('this.item.value', this.item.value)
      }
      this.$router.back()
    }
  }
}
</script>

<style scoped>

</style>
